import { Component, Input } from '@angular/core';

export type SectionIconName = 'question' | 'search' | 'page' | 'domain' | 'request' | 'access' | 'response';

/**
 * Leading icon for a playground .query-section header (styles/_playground.scss).
 * Replaced the old numbered circle: each section says what it is rather
 * than where it sits in the order.
 */
@Component({
  selector: 'app-section-icon',
  standalone: false,
  templateUrl: './section-icon.html',
})
export class SectionIcon {
  @Input({ required: true }) name!: SectionIconName;
}
